import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { queryClient } from "./lib/query";
import { router } from "./router";
import "./styles.css";

// A lazily-imported screen chunk can fail to load right after a deploy: the
// hashed file may not have propagated to this edge yet, or a still-active old
// service worker is mid-swap. Vite raises `vite:preloadError` for exactly this,
// and without a handler it crashes the screen with "Failed to fetch
// dynamically imported module". Reload once to fetch the fresh, network-first
// shell (which references chunks that now exist). The timestamp guard means a
// chunk that is genuinely, permanently gone surfaces the error instead of
// looping the tab.
window.addEventListener("vite:preloadError", (event) => {
  const KEY = "tanzeel:preload-reloaded-at";
  const now = Date.now();
  const last = Number(sessionStorage.getItem(KEY) ?? "0");
  if (now - last < 10_000) return;
  sessionStorage.setItem(KEY, String(now));
  event.preventDefault();
  window.location.reload();
});

const rootElement = document.getElementById("root");
if (rootElement === null) {
  throw new Error("Root element #root is missing from index.html");
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
